const at = name => `[data-tour-scope="orders-list"] [data-tour="${name}"]`;

const EXPORT_CSV = '[data-tour="export-csv"]';
const ADD_ORDER = '[data-tour="add-order"]';
const ROW_EDIT = '[data-tour="row-edit"]';

let checkedRow = false;

function isVisible(selector) {
	const element = document.querySelector(selector);

	if (!element || element.getClientRects().length === 0) {
		return false;
	}

	/*
	 * Un menu che si sta chiudendo resta a schermo per tutta l'animazione, ma
	 * Vuetify gli toglie subito `menuable__content__active`. Senza questo
	 * controllo un menu in chiusura sembrerebbe ancora aperto e il click di
	 * pulizia, invece di chiuderlo, lo riaprirebbe.
	 */
	const content = element.closest('.v-menu__content');

	return !content || content.classList.contains('menuable__content__active');
}

function afterPendingClose() {
	return new Promise(resolve => setTimeout(resolve, 0));
}

async function waitFor(selector, wanted, timeout = 1500) {
	const deadline = performance.now() + timeout;

	while (performance.now() < deadline) {
		if (isVisible(selector) === wanted) {
			return;
		}

		await new Promise(resolve => setTimeout(resolve, 50));
	}
}

function click(selector) {
	const element = document.querySelector(selector);

	if (element) {
		element.click();
	}
}

async function openMenu(activator, probe) {
	await afterPendingClose();

	if (isVisible(probe)) {
		return;
	}

	click(activator);
	await waitFor(probe, true);
}

async function closeMenus() {
	await afterPendingClose();

	for (const [activator, probe] of [
		[at('export'), EXPORT_CSV],
		[at('add'), ADD_ORDER],
		[at('row-menu'), ROW_EDIT],
	]) {
		if (isVisible(probe)) {
			click(activator);
			await waitFor(probe, false);
		}
	}
}

const openExportMenu = () => openMenu(at('export'), EXPORT_CSV);
// senza Shopify il "+" non ha menu e porta subito al nuovo ordine: non va cliccato
const openAddMenu = async () => {
	const button = document.querySelector(at('add'));
	if (button && button.getAttribute('aria-haspopup')) await openMenu(at('add'), ADD_ORDER);
};
const openRowMenu = () => openMenu(at('row-menu'), ROW_EDIT);

async function selectFirstRow() {
	await closeMenus();

	if (isVisible(at('bulk'))) {
		return;
	}

	const box = document.querySelector(`${at('row-check')} input`);

	if (!box) {
		return;
	}

	checkedRow = true;
	box.click();
	await waitFor(at('bulk'), true);
}

export async function stopOrdersListTour() {
	await closeMenus();

	if (checkedRow) {
		checkedRow = false;

		const box = document.querySelector(`${at('row-check')} input`);

		if (box && box.checked) {
			box.click();
		}
	}
}

export function createOrdersListTourSteps() {
	return [
		{
			body: "Questa e' la cabina di regia degli ordini: qui controlli cosa e' entrato dai canali, cosa va preparato, cosa e' gia' stato stampato o spedito, e dove intervenire quando un cliente chiede qualcosa.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'A cosa serve Ordini',
		},
		{
			body: 'I filtri sono pensati per lavorare per coda: testo libero, data ordine, piattaforma, data ordine fornitore, pagamento, stato e tag. Si possono combinare, quindi puoi isolare per esempio gli ordini Shopify pagati ma non ancora evasi.',
			key: 'filters',
			placement: 'bottom',
			target: at('filters'),
			title: 'Filtrare la lista',
		},
		{
			body: "La tabella concentra molti segnali: marketplace, paese e icone operative, poi il numero d'ordine con l'eventuale coupon, la colonna Dettagli che raccoglie uno sotto l'altro cliente, pagamento, spedizione e stato sul marketplace, quindi stato, data ordine fornitore e totale. Il colore della riga arriva dallo stato ordine e aiuta a leggere la priorita' anche a colpo d'occhio.",
			key: 'table',
			placement: 'bottom',
			target: `${at('table')} thead`,
			timeout: 250,
			title: 'Leggere una riga ordine',
		},
		{
			body: "Spuntando una o piu' righe compare la barra massiva. Con una sola riga puoi aprire modifica, riepilogo, tracking e duplica; con piu' righe puoi scaricare, stampare, creare ordini fornitore o cancellare.",
			before: selectFirstRow,
			key: 'bulk',
			placement: 'bottom',
			target: at('bulk'),
			timeout: 250,
			title: 'Azioni multiple',
		},
		{
			body: "Da qui esporti gli ordini in CSV o Excel. L'esportazione segue ricerca, filtri e selezione attiva: e' utile per consegnare al magazzino solo quello che serve davvero.",
			before: openExportMenu,
			key: 'export',
			placement: 'left',
			target: EXPORT_CSV,
			title: 'Esportare ordini',
		},
		{
			body: "Il piu' apre la pagina del nuovo ordine. Se Shopify e' collegato apre un menu dove trovi anche l'importazione di un ordine singolo, di un range e il riepilogo per intervallo.",
			before: openAddMenu,
			key: 'add',
			placement: 'left',
			target: at('add'),
			title: 'Creare o importare',
		},
		{
			body: "I tre pallini sono il menu operativo della singola riga. Le prime voci aprono le pagine dell'ordine, ognuna con il suo tutorial; le altre eseguono azioni rapide come stampa, ricevuta, WhatsApp, ordine fornitore ed eliminazione.",
			before: openRowMenu,
			key: 'row-menu',
			placement: 'right',
			target: ROW_EDIT,
			timeout: 250,
			title: 'Menu ordine',
		},
		{
			body: "Modifica apre la scheda completa dell'ordine: stato, prodotti, totali, indirizzi, comunicazioni, storico e allegati.",
			before: openRowMenu,
			key: 'row-edit',
			placement: 'right',
			target: ROW_EDIT,
			timeout: 250,
			title: 'Modifica',
		},
		{
			body: "Riepilogo mostra la vista leggibile dell'ordine con barcode, dati cliente, spedizione, fatturazione, prodotti e totali. E' la vista migliore per controllare tutto senza modificare niente.",
			before: openRowMenu,
			key: 'row-summary',
			placement: 'right',
			target: '[data-tour="row-summary"]',
			timeout: 250,
			title: 'Riepilogo',
		},
		{
			body: "Stampa prepara l'ordine per la stampa operativa, mentre Ricevuta apre il documento ricevuta in una nuova scheda. Entrambe passano prima dal flusso che marca l'ordine come in elaborazione.",
			before: openRowMenu,
			key: 'row-print',
			placement: 'right',
			target: '[data-tour="row-print"]',
			timeout: 250,
			title: 'Stampa e ricevuta',
		},
		{
			body: "WhatsApp compare quando il numero e' valido: apre la conversazione con un messaggio collegato all'ordine. E' utile per conferme indirizzo, note su spedizioni o chiarimenti rapidi.",
			before: openRowMenu,
			key: 'row-whatsapp',
			placement: 'right',
			target: '[data-tour="row-whatsapp"]',
			timeout: 250,
			title: 'Contatto WhatsApp',
		},
		{
			body: 'Duplica crea un nuovo ordine partendo da quello scelto. Serve quando devi ripetere un ordine simile senza ricostruire cliente, prodotti e totali da zero.',
			before: openRowMenu,
			key: 'row-duplicate',
			placement: 'right',
			target: '[data-tour="row-duplicate"]',
			timeout: 250,
			title: 'Duplica',
		},
		{
			body: "Tracking apre la vista per corriere, codice tracking e quantita' spedita. Da li' puoi copiare i dati per singola riga o salvare la spedizione sull'ordine.",
			before: openRowMenu,
			key: 'row-tracking',
			placement: 'right',
			target: '[data-tour="row-tracking"]',
			timeout: 250,
			title: 'Tracking',
		},
		{
			body: "Ordine Fornitore porta l'ordine nel flusso di preparazione/acquisto; se e' gia' stato creato, qui trovi l'azione inversa per annullarlo.",
			before: openRowMenu,
			key: 'row-supplier',
			placement: 'right',
			target: '[data-tour="row-supplier"]',
			timeout: 250,
			title: 'Ordine fornitore',
		},
		{
			body: "Elimina rimuove l'ordine dopo conferma. E' l'ultima opzione del menu proprio per evitare click distratti mentre si lavora sulle righe.",
			before: openRowMenu,
			key: 'row-delete',
			placement: 'right',
			target: '[data-tour="row-delete"]',
			timeout: 250,
			title: 'Elimina',
		},
	];
}
